import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './iconFont/essentials/flaticon.css';
import './iconFont/essentialsFill/flaticon.css';
import './iconFont/carparts/style.css';
import './iconFont/alarms/style.css';
import './iconFont/air/style.css';
import './iconFont/contactus/flaticon.css';
import './iconFont/contactusFill/flaticon.css';

import registerServiceWorker from './registerServiceWorker';

import RouterAuth from './components/RouterAuth';
import * as stores from './stores';
import translationsStore from 'air-translations-store';

import { Provider } from 'mobx-react';

import { LocaleProvider } from 'antd';

import it_IT from 'antd/lib/locale-provider/it_IT';
import en_US from 'antd/lib/locale-provider/en_US';
import de_DE from 'antd/lib/locale-provider/de_DE';

import it from './translations/it';
import en from './translations/en';
import de from './translations/de';

import 'moment/locale/it';
import moment from 'moment';

translationsStore.addTranslation('it', it);
translationsStore.addTranslation('en', en);
translationsStore.addTranslation('de', de);

const [language] = (navigator.language || navigator.userLanguage || 'en').split('-');

let locale = en_US;
moment.locale('en');
translationsStore.setLocale('en');

if (language === 'it') {
  locale = it_IT;
  moment.locale('it');
  translationsStore.setLocale('it');
}

if (language === 'de') {
  locale = de_DE;
  moment.locale('de');
  translationsStore.setLocale('de');
}

const m = moment();

stores['commonStore'].setLongDateFormat(m._locale._longDateFormat);

stores.authStore.checkSession().then(() => {
  // let's do http to https redirect check according to environment
  if (window.location.hostname !== 'localhost' && window.location.protocol !== 'https:') {
    window.location = 'https:' + window.location.href.substring(window.location.protocol.length);
    return;
  }
  ReactDOM.render(
    <LocaleProvider locale={locale}>
      <Provider {...stores} translationsStore={translationsStore}>
        <RouterAuth />
      </Provider>
    </LocaleProvider>,
    document.getElementById('root')
  );
});

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js